import(/* webpackMode: "eager", webpackExports: ["Empty"] */ "__barrel_optimize__?names=Empty!=!/var/www/academy-frontend/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "__barrel_optimize__?names=Tabs!=!/var/www/academy-frontend/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/academy-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/common/image/CommonImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/pages/home/instructorDetails/tabContent/CourseInfo.js");
